import React from 'react';
import { GiftIcon } from 'lucide-react';
export function OfferBar() {
  return <section aria-label="Bonos de regalo" className="bg-petrol-800 text-cream" data-id="element-245" data-mp="1csft89j6gyz0">
      <a href="#bonos" className="mx-auto flex max-w-6xl items-center justify-center gap-2.5 px-5 py-3.5 transition-opacity duration-150 ease-out hover:opacity-90 sm:gap-3 sm:py-4" data-id="element-246" data-mp="1cqd4rtxobdwe">
        <GiftIcon className="h-5 w-5 shrink-0 text-gold-400" aria-hidden="true" data-id="element-247" data-mp="yseup0qdy3mp" />
        <p className="text-balance text-center font-serif text-base leading-snug sm:text-xl" data-id="element-248" data-mp="yuiwnd4q4skc">
          Ahorrá tiempo y conseguí <span className="text-gold-300" data-id="element-249" data-mp="17t39hxnls80n">más clientes</span>
        </p>
      </a>
    </section>;
}